<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon
        color="green"
        v-on="on"
      >
        <v-icon>
          mdi-check-bold
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-text class="font-weight-bold">
        Are you sure you want to set this claim request (Ref. No. {{ claimRequest.reference_number }}) as complete?
      </v-card-text>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          class="white--text"
          color="hrissecondary"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions> 
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimRequest: {
        type: Object,
        required: true,
      },
      company: {
        type: Object,
        required: true,
      },
    }, 
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.progressing = true

            this.$api.claimApprovals().complete(this.claimRequest.approval_request.latest_approval.id, { company_uid: this.company.company_uid })
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.status })

                this.$api.claimApprovals().pendingCount()
                  .then(response => {
                    this.setClaimPendingCount(response.data)
                  })
                  .catch(() => {})
                  
                this.menu = false
              })
              .catch(error => {
                if (error.response.status >= 400 && error.response.status < 500) {
                  this.$snack({ 
                    color: 'error',
                    message: error.response.data.message, 
                  })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
